import React, { Component, useState, useEffect } from 'react'
import { useAuth, apiFetch } from "../hooks/useAuth";
// import {
//     DataGrid, GridRowsProp, GridColDef,
//     GridToolbarContainer, GridToolbarExport, GridActionsCellItem
// } from '@mui/x-data-grid';

import { DataGridPro, GridToolbar, GridToolbarContainer, GridToolbarExport, GridActionsCellItem, useGridApiRef } from '@mui/x-data-grid-pro';

import EmailIcon from '@mui/icons-material/Email';
import SquareIcon from '@mui/icons-material/Square';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PrintIcon from '@mui/icons-material/Print';

import {
    IconButton, FormControlLabel, Stack, Alert,
    LinearProgress, Box, Modal, Typography, Tooltip, Button
} from "@mui/material/";
import dayjs from 'dayjs';
import { ModalDownload, ModalContact } from "./Modal";
import { deDE } from '@mui/x-data-grid-pro/locales'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "80%",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    height: 600,
    p: 4,
};

export function AboListUmlauf() {
    const { user, change, claims, accountID } = useAuth();
}

export function AboList() {
    const { user, change, claims, accountID } = useAuth();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('');
    const [message, setMessage] = useState("");
    const [data, setData] = useState([]);
    const [dataUmlauf, setDataUmlauf] = useState([]);
    const [open, setOpen] = useState(false);
    const [openUmlauf, setOpenUmlauf] = useState(false);
    const [openLieferhistorie, setOpenLieferhistorie] = useState(false);
    const token = useAuth().token; // funktioniert nur so

    const [currentRow, setCurrentRow] = useState(null);

    const [isModalDownloadOpen, setIsModalDownloadOpen] = useState(false);
    const [isModalContactOpen, setIsModalContactOpen] = useState(false);

    const apiRef = useGridApiRef();

    const currencyFormatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

    // Custom print function that extracts all data and creates a printable view
    const handlePrint = () => {
        const visibleColumns = apiRef.current.getVisibleColumns();
        const allRows = apiRef.current.getSortedRowIds().map(id => apiRef.current.getRow(id));
        
        // Create a new window for printing
        const printWindow = window.open('', '_blank');
        
        // Build HTML with all rows
        const html = `
            <!DOCTYPE html>
            <html>
            <head>
                <title>Abostatus Drucken</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        margin: 20px;
                    }
                    h1 {
                        font-size: 18px;
                        margin-bottom: 20px;
                    }
                    table {
                        border-collapse: collapse;
                        width: 100%;
                        font-size: 10px;
                    }
                    th, td {
                        border: 1px solid #ddd;
                        padding: 6px;
                        text-align: left;
                    }
                    th {
                        background-color: #f5f5f5;
                        font-weight: bold;
                    }
                    tr:nth-child(even) {
                        background-color: #fafafa;
                    }
                    @media print {
                        body { margin: 10px; }
                    }
                </style>
            </head>
            <body>
                <h1>Abostatus - ${new Date().toLocaleDateString('de-DE')}</h1>
                <table>
                    <thead>
                        <tr>
                            ${visibleColumns.filter(col => col.field !== 'Reklamation' && col.field !== 'Umlauf' && col.field !== 'Lieferhistorie').map(col => 
                                `<th>${col.headerName || col.field}</th>`
                            ).join('')}
                        </tr>
                    </thead>
                    <tbody>
                        ${allRows.map(row => `
                            <tr>
                                ${visibleColumns.filter(col => col.field !== 'Reklamation' && col.field !== 'Umlauf' && col.field !== 'Lieferhistorie').map(col => {
                                    let value = row[col.field];
                                    
                                    // Format dates
                                    if ((col.field === 'nächste Lieferung' || col.field === 'Startdatum') && value) {
                                        value = dayjs(value).format('DD.MM.YYYY');
                                    }
                                    // Format currency
                                    else if (col.field === 'Preis' && value) {
                                        value = currencyFormatter.format(value);
                                    }
                                    
                                    return `<td>${value || ''}</td>`;
                                }).join('')}
                            </tr>
                        `).join('')}
                    </tbody>
                </table>
            </body>
            </html>
        `;
        
        printWindow.document.write(html);
        printWindow.document.close();
        
        // Wait for content to load, then print
        printWindow.onload = () => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
        };
    };

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbar printOptions={{ disableToolbarButton: true }} />
                <Button
                    startIcon={<PrintIcon />}
                    onClick={handlePrint}
                    size="small"
                >
                    Drucken
                </Button>
            </GridToolbarContainer>
        );
    }

    const handleCloseUmlauf = () => {
        setError("");
        setOpenUmlauf(false);
    }

    const handleOpenUmlauf = (row) => {
        setOpenUmlauf(true);

        var orderID = null;
        if (row.AuftragNr !== null) {
            orderID = row.AuftragNr;
        }

        if (!orderID) {
            setError("Keine Auftragsnummer verfügbar");
            return;
        }

        apiFetch("/app/abos/umlauf/" + accountID + "/" + orderID)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Die Daten konnten nicht geladen werden. ');
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                console.log(data);
                setDataUmlauf(data);

                if (data.message)
                    setMessage(data.message);
            })
            .catch((err) => {
                setLoading(false);
                setError(err.message);
            });

    }

    const handleCloseLieferhistorie = () => {
        setError("");
        setOpenLieferhistorie(false);
    }

    const handleOpenLieferhistorie = (row) => {
        setOpenLieferhistorie(true);

        var orderID = null;
        if (row.AuftragNr !== null) {
            orderID = row.AuftragNr;
        }
        if (process.env.REACT_APP_DEPLOYED === 'schoeningh') {
            orderID = orderID + "-" + row.AuftragPosLfdnr;
        }

        if (!orderID) {
            setError("Keine Auftragsnummer verfügbar");
            return;
        }

        apiFetch("/app/abos/lieferungen/" + accountID + "/" + orderID)
            .then((res) => {
                if (!res.ok) {
                    throw new Error('Die Daten konnten nicht geladen werden. ');
                }
                return res.json();
            })
            .then((data) => {
                setLoading(false);
                console.log(data);
                setDataUmlauf(data);

                if (data.message)
                    setMessage(data.message);
            })
            .catch((err) => {
                setLoading(false);
                setError(err.message);
            });

    }

    useEffect(() => {
        setData("");

        if (!accountID) {
            setError("Es wurde keine AccountID ausgewaehlt");
            return;
        }

        if (!token) {
            setError("Es gibt keinen definierten User Token");
            return;
        }
        setLoading(true);

        apiFetch("/app/abos/" + accountID)
            .then((res) => res.json())
            .then((data) => {
                setLoading(false);
                console.log(data);
                setData(data)
                if (data.message)
                    setMessage(data.message);
            })
            .catch((err) => {
                setLoading(false);
                setError(err.message);
            });
    }, [accountID]);

    return (

        <div style={{ height: "670px", width: '100%' }}>
            <Box
                mt={2}
                mb={2}
                sx={{ width: '100%', height: 4 }}>
                {loading && <LinearProgress />}

            </Box>

            {error && <Alert severity="error">{error}</Alert>}
            {message && <Alert severity="info">{message}</Alert>}


            <Modal
                open={openUmlauf}
                onClose={handleCloseUmlauf}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <DataGridPro
                        pageSize={10}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        components={{
                            Toolbar: CustomToolbar,
                        }}

                        initialState={{ pinnedColumns: { right: ['Reklamation'] } }}
                        rows={dataUmlauf}
                        columns={[
                            {
                                field: 'AuftragNr',
                                headerName: "AuftragsNr.",
                            },
                            {
                                field: 'Adressat',
                                headerName: "Adressat",
                                width: "180"
                            },
                            {
                                field: 'AuftragPosLfdnr',
                                headerName: "AuftragPosLfdnr"
                            },
                            {
                                field: 'Kostenstelle',
                                headerName: "Kostenstelle"
                            },
                            {
                                field: 'Pos',
                                headerName: "Pos"
                            },
                            {
                                field: 'Titel',
                                headerName: "Titel",
                                width: "230",
                            },

                        ]}
                    />
                </Box>
            </Modal>

            <Modal
                open={openLieferhistorie}
                onClose={handleCloseLieferhistorie}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>

                    <DataGridPro
                        pageSize={10}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        components={{
                            Toolbar: CustomToolbar,
                        }}



                        initialState={{ pinnedColumns: { right: ['Reklamation'] } }}
                        rows={dataUmlauf}
                        columns={[
                            {
                                field: 'AuftragNr',
                                headerName: "AuftragsNr.",
                            },
                            {
                                field: 'Titel',
                                headerName: "Titel",
                                width: "250",
                            },
                            {
                                field: 'AuftragPosLfdnr',
                                headerName: "AuftragPosLfdnr"
                            },
                            {
                                field: 'Lieferung',
                                headerName: "Lieferung",
                                width: "250",
                            },
                            {
                                field: 'Datum',
                                headerName: "Datum",
                                type: "date",
                                valueFormatter: (params) => dayjs(params).format('DD.MM.YYYY'),
                            },
                            {
                                field: 'Preis',
                                headerName: "Preis",
                                type: "number",
                                valueFormatter: (params) => currencyFormatter.format(params),
                            },
                            {
                                field: 'Belegart',
                                headerName: "Belegart",
                            },
                            {
                                field: 'Belegnummer',
                                headerName: "Belegnummer",
                            },


                        ]}
                    />
                </Box>
            </Modal>

            <ModalDownload row={currentRow} isModalOpen={isModalDownloadOpen} handleCloseModal={() => setIsModalDownloadOpen(false)} />
            <ModalContact row={currentRow} isModalOpen={isModalContactOpen} handleCloseModal={() => setIsModalContactOpen(false)} />

            <div style={{ display: 'flex', height: '100%' }}>
                <div style={{ flexGrow: 1 }}>
                    <DataGridPro
                        apiRef={apiRef}
                        pageSize={10}
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        components={{
                            Toolbar: CustomToolbar
                        }}
                        // // getRowId={(row) => row.AuftragNr}
                        slots={{ toolbar: CustomToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                            },
                            filterPanel: {
                                onKeyDown: (event) => {
                                    console.log(event.key);
                                    if (event.key === 'Enter') {
                                        apiRef.current.hideFilterPanel()
                                    }
                                }
                            }
                        }}

                        initialState={{ pinnedColumns: { right: ['Reklamation'] } }}
                        rows={data}
                        columns={[

                            {
                                field: 'AuftragNr',
                                headerName: "AuftragsNr.",
                                width: 90
                            },
                            {
                                field: 'KDNR',
                                headerName: "KundenNr.",
                                width: 85
                            },
                            {
                                field: 'Titel',
                                width: 360
                            },
                            {
                                field: 'Anzahl',
                                width: 60
                            },
                            {
                                field: 'Gesamtbetrag',
                                // valueFormatter: (params) => {
                                //     return params.value.toFixed(2) + " €";
                                // },
                                valueFormatter: (params) => {
                                    return currencyFormatter.format(params);
                                },
                                headerName: "Betrag",
                                type: "number",
                                width: 80,
                            },
                            {
                                field: 'Bestelldatum1',
                                headerName: "bestellt am",
                                type: "date",
                                valueFormatter: (params) => dayjs(params).format('DD.MM.YYYY'),
                            },
                            {
                                field: 'Hinweis',
                                width: 180
                            },
                            {
                                field: 'Kostenstelle'
                            },
                            /*{
                                field: 'ISBN'
                            },*/
                            // {
                            //     field: 'ErscheintAm',
                            //     headerName: "erscheint am",
                            //     width: 150
                            // },
                            {
                                field: 'geliefertAm',
                                headerName: "letzte Lieferung",
                                width: 120
                            },
                            {
                                field: 'actions',
                                type: 'actions',
                                headerName: 'Umlauf',
                                width: 80,
                                getActions: (params) => {
                                    if (params.row.Umlauf !== 0) {
                                        return (
                                            [
                                                <GridActionsCellItem
                                                    onClick={() => {
                                                        handleOpenUmlauf(params.row);
                                                    }}
                                                    icon={<AddCircleOutlineIcon />}
                                                    label="Umlauf" />
                                            ]
                                        )
                                    } else {
                                        return (
                                            [
                                                <></>
                                            ]
                                        )
                                    }

                                },
                            },
                            {
                                field: 'actions2',
                                type: 'actions',
                                headerName: 'Aktionen',
                                width: 120,
                                getActions: (params) => [
                                    <Tooltip title="Reklamation">
                                        <GridActionsCellItem
                                            onClick={() => {
                                                // handleOpen(params.row);
                                                setCurrentRow(params.row);
                                                setIsModalContactOpen(true);

                                            }}
                                            icon={<EmailIcon />} label="Reklamation" />

                                    </Tooltip>,

                                    <Tooltip title="Belege herunterladen">
                                        <GridActionsCellItem
                                            onClick={() => {
                                                // handleOpenDownload(params.row);
                                                setCurrentRow(params.row);
                                                setIsModalDownloadOpen(true);
                                            }}
                                            icon={<CloudDownloadIcon />} label="Download" />

                                    </Tooltip>,

                                    <Tooltip title="Lieferhistorie anzeigen">
                                        <GridActionsCellItem
                                            onClick={() => {
                                                // handleOpenDownload(params.row);
                                                setCurrentRow(params.row);
                                                handleOpenLieferhistorie(params.row);
                                            }}
                                            icon={<DeliveryDiningIcon />} label="Lieferung" />

                                    </Tooltip>,
                                ],
                            },
                        ]}
                    />
                </div>
            </div>

        </div >
    )
}

